import Cookies from 'js-cookie';

export const LOGGED_IN_USER_KEY = 'logged_in_user';
export const PAYMENT_PROFILE_KEY = 'payment_profiles';
export const MERCHANT_PROFILE_DETAIL_KEY = 'merchant_profile_details';
export const CURRENT_PAYMENT_PROFILE_KEY = 'current_payment_profile';
export const REGISTERED_USER_KEY = 'registered_user';
export const ENVIRONMENT_KEY = 'environment';

const allCookies: Array<string> = [
  LOGGED_IN_USER_KEY,
  PAYMENT_PROFILE_KEY,
  MERCHANT_PROFILE_DETAIL_KEY,
  CURRENT_PAYMENT_PROFILE_KEY,
  REGISTERED_USER_KEY,
  ENVIRONMENT_KEY,
];

export const setCookie = (name: string, value: string) => {
  // Cookies.set(name, value, {});
  localStorage.setItem(name, value);
};

export const getCookie = (name: string) => {
  // return Cookies.get(name);
  return localStorage.getItem(name);
};

export const deleteCookie = (name: string) => {
  // Cookies.remove(name);
  localStorage.removeItem(name);
};

export const deleteAllCookie = () => {
  // allCookies.forEach((cookie: string) => {
  //   deleteCookie(cookie);
  // });
  localStorage.clear();
};

export const getLoggedInUser = (): any => {
  const loggedInUser = getCookie(LOGGED_IN_USER_KEY) as string;
  if (loggedInUser) {
    return JSON.parse(loggedInUser);
  }

  return '';
};

export const getCurrentPaymentProfile = () => {
  const profile = getCookie(CURRENT_PAYMENT_PROFILE_KEY);
  if (profile && profile !== 'undefined') {
    return JSON.parse(profile);
  }

  return '';
};

export const getMerchantProfile = () => {
  const merchant = getCookie(MERCHANT_PROFILE_DETAIL_KEY) as string;
  if (merchant) {
    return JSON.parse(merchant);
  }

  return '';
};

export const getAccountProfileDetails = () => {
  const accountProfileDetails = getCookie('account_profile_details') as string;
  if (accountProfileDetails) {
    return JSON.parse(accountProfileDetails);
  }

  return '';
};

export const getEnvironmentStatus = () => {
  return getCookie(ENVIRONMENT_KEY) as string;
};

export const isSandboxEnvironment = () => {
  const env = getCookie(ENVIRONMENT_KEY) as string;
  return env === 'sandbox';
};
